import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MarkerCardStyle } from "../../pages/CrmMarker/CrmMarkerStyle";
import Button from "../Button/Button";
import Typography from "../Typography/Typography";

const MarkerCard = ({
  children,
  title,
  button,
  scrollabel,
  onerow,
  chart,
  filter,
  app,
}) => {
  const [height, setHeight] = useState("180px");
  const navigate = useNavigate();
  return (
    <MarkerCardStyle
      height={!scrollabel && !onerow ? "230px" : onerow ? "130px" : height}
      overflow={!scrollabel ? "unset" : "hidden"}
    >
      <div className="content">
        <div className="d-flex">
          <div className="p-1 w-75">
            <Typography color="#545454">{title}</Typography>
          </div>
          <div className="d-flex w-25 justify-content-end">
            {chart ? (
              <Button
                small="fit-content"
                className="px-1 py-0 m-0"
                size="10px"
                bgColor="#f7f7f7"
                style={{ border: "1px solid #d7d7d7" }}
                onclick={() =>
                  navigate(`/dashboard/crm/${app ? "ChartApp" : "Chart"}`, {
                    state: filter,
                  })
                }
              >
                نمودار کامل
              </Button>
            ) : null}
            {button}
          </div>
        </div>
        {children}
      </div>
      {scrollabel ? (
        <div className="d-flex w-100 justify-content-end">
          <Button
            size="12px"
            onclick={() =>
              scrollabel && height === "180px"
                ? setHeight("fit-content")
                : setHeight("180px")
            }
          >
            نمایش {height === "fit-content" ? "کمتر" : "بیشتر"}
          </Button>
        </div>
      ) : null}
    </MarkerCardStyle>
  );
};

export default MarkerCard;
